<template>
  <v-container class="mt-4">
    <v-row>
      <v-col class="d-flex flex-wrap justify-center">
        <option-menu
          v-for="option in options"
          :key="option.title"
          :option="option"
          class="ma-3"
        >
        </option-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';

import OptionMenu from '@/components/OptionMenu.vue';

export default {
  name: 'mainMenu',
  components: {
    'option-menu': OptionMenu,
  },
  data() {
    return {
      allOptions: [
        {
          id: 'project_startup',
          icon: 'mdi-folder-plus',
          title: 'project startup',
          to: { name: 'project-startup' },
          description: 'Create projects in BIM 360',
        },
        {
          id: 'projects_administration',
          icon: 'mdi-folder-settings',
          title: 'PROJECTS ADMINISTRATION',
          to: { name: 'projects-administration' },
          description: 'Manage BIM 360 project settings and user permissions',
        },
        {
          id: 'access_projects',
          icon: 'mdi-folder-key',
          title: 'ACCESS PROJECTS',
          to: { name: 'access-projects' },
          description: 'Request access to a specific BIM 360 project',
        },
        {
          id: 'viewer',
          icon: 'mdi-cube-scan',
          title: 'viewer',
          to: { name: 'viewer' },
          description: 'Visualize, review and share 2d and 3d documents hosted in BIM 360',
        },
        {
          id: 'dashboard',
          icon: 'mdi-monitor-dashboard',
          title: 'dashboard',
          to: { name: 'dashboard' },
          description: 'Data visualizations based on Bim 360 projects and users',
        },
        {
          id: 'publish_model',
          icon: 'mdi-calendar-clock',
          title: 'PUBLISH MODEL',
          to: { name: 'publish-model' },
          description: 'Publish the latest updates of Revit models',
        },
        {
          id: 'international_framework_content',
          icon: 'mdi-image-outline',
          title: 'INTERNATIONAL FRAMEWORK content',
          to: { name: 'international-framework-content' },
          description: 'Explore sheets and views of regional framework templates',
        },
        {
          id: 'app_settings',
          icon: 'mdi-cog',
          title: 'APP SETTING',
          to: { name: 'app-settings' },
          description: 'General application settings',
        },
      ],
      options: [],
    };
  },
  computed: {
    ...mapState('profile', ['userLoggedIn']),
  },
  created() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      if (!this.$route.params.token) {
        const services = this.userLoggedIn.services
          .map((service) => {
            const keyService = Object.keys(service).find(key => (key !== 'permissions' && key !== 'conditions'));
            return { [keyService]: service[keyService] };
          })
          .filter(service => Object.values(service)[0])
          .map(service => Object.keys(service)[0]);
        this.options = this.allOptions.filter(option => services.includes(option.id));
      }
    },
  },
};
</script>
